import store from '../../../store/store';
import { PerformSearchParams, PredefinedFilter, SearchFacet } from '../interfaces/search.interface';
import { StoreState } from '../../../store/store.interface';
import { selectPredefinedFilters } from '../store/search.selector';
import { PredefinedFiltersObjects } from '../interfaces/predefined-filters.interface';

/**
 * Checks if the facet is pre-filtered.
 *
 * @param facet
 */
export function isFacetPreFiltered(facet: SearchFacet): boolean {
  const predefinedFilters: Array<PredefinedFilter> = selectPredefinedFilters(store.getState() as StoreState);
  if (!predefinedFilters) {
    return false;
  }

  return predefinedFilters.some(filter => filter.filterName === facet.name);
}

/**
 * Adds predefined filters to the search request.
 *
 * @param request
 * @param predefinedFilters
 */
export function addPredefinedFilters(
  request: PerformSearchParams,
  predefinedFilters: PredefinedFilter[]
): PerformSearchParams {
  if (!predefinedFilters || predefinedFilters.length === 0) {
    return request;
  }

  for (const predefinedFilter of predefinedFilters) {
    const filterValues: Array<string> = predefinedFilter.filterValues.map(value => cleanFilterValueName(value));

    request.fieldValueFilter = {
      ...request.fieldValueFilter,
      [predefinedFilter.filterName]: filterValues
    };
  }

  return request;
}

/**
 * Removes underscores from filter value name except the first one.
 *
 * @param filterValueName
 */
export function cleanFilterValueName(filterValueName: string): string {
  return filterValueName.replace(/_/g, (s, i) => i > 0 ? ' ' : s);
}

export function cleanFilterValues(predefinedFilters: any[]): string[] {
  const predefinedFiltersArr: string[] = [];
  predefinedFilters?.map(predefinedFilter => {
    predefinedFilter.filterValues.forEach((value: string) => predefinedFiltersArr.push(cleanFilterValueName(value)));
  });
  return predefinedFiltersArr;
}

export function createPredefinedFiltersObjectList(facets: SearchFacet[], predefinedFiltersArr: string[]): PredefinedFiltersObjects[] {
  const predefinedFiltersObjectList: PredefinedFiltersObjects[] = [];

  facets?.map((facet) => {
    const filterName = facet.name;
    facet.facetValues
      .filter((value) => value?.selected)
      .forEach((selectedFacet) => {
        if (predefinedFiltersArr.includes(selectedFacet.name)) {
          predefinedFiltersObjectList.push({
            filterName: filterName,
            name: selectedFacet.name,
            label: selectedFacet.label,
          });
        }
      });
  });

  return predefinedFiltersObjectList;
}